module.exports = __webpack_public_path__ + "img/Surquillo.63131193.svg";